import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import axios from 'axios';
import logo from './logo_top.png';

const Login = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 1. Dobijanje tokena
      const response = await axios.post('/api-token-auth/', values);
      
      if (response.data.token) {
        const token = response.data.token;
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Token ${token}`;
        
        // ODMAH PROVERAVAMO USERNAME IZ FORME
        let targetPath = '/';
        if (values.username === 'mondoline') {
          targetPath = '/video-editor-2';
        }

        // 2. Preuzimanje ostalih podataka (perms, superuser...) u pozadini
        try {
          const userResponse = await axios.get('/api/users/manage/');
          const currentUser = userResponse.data.find(u => u.username === values.username);
          
          if (currentUser) {
            localStorage.setItem('user', JSON.stringify(currentUser));
          }
        } catch (userError) {
          console.error("Greška pri preuzimanju podataka o korisniku:", userError);
        }

        message.success('Login successful');
        
        // PREUSMERAVANJE
        setTimeout(() => {
          window.location.href = targetPath;
        }, 500);
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      height: '100vh', background: '#0f172a', display: 'flex', 
      justifyContent: 'center', alignItems: 'center', padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ 
          background: '#1e293b', padding: '15px 20px', borderRadius: '8px 8px 0 0', 
          border: '1px solid #334155', borderBottom: '3px solid #3b82f6', display: 'flex', alignItems: 'center'
        }}>
          <img src={logo} alt="logo" style={{ height: '40px' }} />
        </div>

        <div style={{ 
          background: 'rgba(30, 41, 59, 0.3)', padding: '32px 24px', borderRadius: '0 0 12px 12px', 
          border: '1px solid #1e293b', borderTop: 'none'
        }}>
          <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
            <Form.Item 
              name="username" 
              label={<span style={{ color: '#64748b', fontSize: '11px', textTransform: 'uppercase' }}>Username</span>}
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input 
                prefix={<UserOutlined style={{ color: '#64748b' }} />} 
                style={{ background: '#0f172a', color: 'white', border: '1px solid #334155', height: '40px' }}
              />
            </Form.Item>

            <Form.Item 
              name="password" 
              label={<span style={{ color: '#64748b', fontSize: '11px', textTransform: 'uppercase' }}>Password</span>}
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input.Password 
                prefix={<LockOutlined style={{ color: '#64748b' }} />} 
                style={{ background: '#0f172a', color: 'white', border: '1px solid #334155', height: '40px' }}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: '30px', marginBottom: '0px' }}>
              <Button 
                type="primary" htmlType="submit" loading={loading} block icon={<LoginOutlined />}
                style={{ background: '#3b82f6', border: 'none', height: '45px', fontWeight: 'bold', textTransform: 'uppercase' }}
              >
                LOGIN
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px', color: '#64748b', fontSize: '11px' }}>
          <span>BUILD V1.0.4-STABLE</span>
        </div>
      </div>
      <style>{`
        .ant-input-affix-wrapper { background: #0f172a !important; border: 1px solid #334155 !important; }
        .ant-input-affix-wrapper input { background: transparent !important; color: white !important; }
        .ant-input-password-icon { color: #64748b !important; }
      `}</style>
    </div>
  );
};

export default Login;